import React, { useState } from "react";
import PropTypes from "prop-types";
import { ReactComponent as CopyIcon } from "@/assets/images/mercadoCopy.svg";
import { ReactComponent as CopiedIcon } from "@/assets/images/check.svg";
import { ReactComponent as EditIcon } from "@/assets/images/pencil.svg";

export function FakeInput1xbet({
  label = "",
  value = "",
  description = "",
  dataCopy,
  className,
  isEditable,
  onClick,
}) {
  const [isCopied, setIsCopied] = useState(false);

  const handleAction = async (e) => {
    if (isEditable && onClick) {
      onClick(e);
      return;
    }

    if (dataCopy) {
      try {
        await navigator.clipboard.writeText(dataCopy);
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 2000);
      } catch (err) {
        console.error("Error al copiar al portapapeles:", err);
      }
    }
  };

  const isClickable = isEditable || dataCopy;

  return (
    <div
      onClick={handleAction}
      className={`flex flex-col w-full gap-1 py-2 px-5 items-start transition-colors bg-mercago-light-cyan ${
        isClickable
          ? "cursor-pointer hover:bg-mercado-light-cyan-hov"
          : "cursor-default"
      } ${className}`}
      role={isClickable ? "button" : undefined}
      tabIndex={isClickable ? 0 : undefined}
      onKeyDown={(e) =>
        isClickable && (e.key === "Enter" || e.key === " ") && handleAction(e)
      }
      aria-label={isEditable ? `Editar ${label}` : `Copiar ${label}`}
    >
      <span className="text-sm text-dark-gray leading-tight">{label}</span>

      <div className="flex h-8 justify-between relative items-center w-full gap-3">
        <span
          className={`min-w-0 font-semibold break-words leading-none ${
            isCopied ? "text-mercado-green" : "text-black"
          }`}
        >
          {value}
        </span>

        <div className="flex items-center gap-2 flex-shrink-0">
          {isEditable && <EditIcon className="h-[18px] text-gray-600" />}

          {!isEditable && dataCopy && (
            <div className="flex items-center justify-center p-1.5 rounded-md transition-all">
              {isCopied ? (
                <CopiedIcon className="w-5 h-5 text-mercado-green" />
              ) : (
                <CopyIcon className="w-[1.1rem] h-[1.1rem]" />
              )}
            </div>
          )}
        </div>

        {description && (
          <span className="ml-2 text-dark-gray text-xs flex-shrink-0">
            {description}
          </span>
        )}
      </div>
    </div>
  );
}

FakeInput1xbet.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  dataCopy: PropTypes.string,
  description: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  isEditable: PropTypes.bool,
};
